import { IFile } from "../domain/models/File";
import { INews } from "../domain/models/News";
import { BaseModelImpl } from "./BaseModelImpl";

export class NewsFlatModel extends BaseModelImpl<INews> implements INews {
    id: string;
    files?: IFile[];

    languageCode: string;

    title: string;
    content: string;
    shortContent: string;

    creatorId: string;
    createdAt?: Date;
    updatedAt?: Date;

    constructor(data?: INews) {
        super();
        this.assignData(data);
    }
}
